import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {HTTP_INTERCEPTORS} from '@angular/common/http';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FormsModule } from '@angular/forms';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { AuthService } from './shared/services/auth.service';
import { environment } from 'src/environments/environment.generated';
import { MockInterceptor } from './core/interceptors/mock.interceptor';
import { CommonModule } from '@angular/common';
import { SessionTimerService } from './shared/services/session-timer.service';
import {TranslateModule} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import {DBIconModule, provideDbcrIcons} from "@db/db-core";

export function initializeAuth(authService: AuthService) {
  return () => {
    authService.initializeForgerock();
  }
}

export function initializeSessionTimer(sessionTimer: SessionTimerService) {
  return () => { }
}

@NgModule({
  imports: [
    DBIconModule.forRoot(),
    BrowserModule,
    FormsModule,
    NgbModule,
    CommonModule,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: "./assets/i18n/",
        suffix: ".json",
        enforceLoading: true,    // Adds cache-busting timestamp
        useHttpBackend: true
      }),
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSessionTimer,
      deps: [SessionTimerService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    (environment.mock ? [{
      provide: HTTP_INTERCEPTORS,
      useClass: MockInterceptor,
      multi: true
    }] : []),
    provideDbcrIcons()
  ]
})
export class AppModule { }
